import socialIcons from "@/components/social-icons/social-icons.vue";
import newsletterForm from "@/components/newsletter-form/newsletter-form.vue";

export default {
  components: {
    socialIcons,
    newsletterForm,
  },
};
